/*
 * @Author: yubaolee <yubaolee@163.com> | ahfu~ <954478625@qq.com>
 * @Date: 2021-06-01 14:10:29
 * @LastEditTime: 2022-12-15 20:44:58
 * @Description: 顶部tag缓存
 * @
 * @Copyright (c) 2022 by yubaolee | ahfu~ , All Rights Reserved. 
*/
import { local } from '@/utils'
import { start } from 'nprogress'
const tagsView = {
  state: {
    visitedViews: [],
    cachedViews: [],
    iframeViews: {},
    showtrue: false
  },
  mutations: {
    ADD_VISITED_VIEWS: (state, view) => {

      if (state.visitedViews.length <= 0) {
        state.visitedViews = local.getItem('visitedViews') || []
      }

      if (state.visitedViews.some(v => v.path === view.path)) return

      var visit = {
        //如果这个地方用view.name，当name相同（即模块名称相同）时，visitedViews所有的path都是相同的，且都是SysLogs/Index，很诡异的BUG😂
        name: view.path.replaceAll('/', '_'),
        path: view.path,
        params: view.params,
        meta: view.meta,
        title:
          view.name === 'iframePage'
            ? state.iframeViews[view.params.code].name
            : view.meta.title || 'no-name',
      }

      state.visitedViews.push(visit)
      // state.visitedViews.forEach(x=>{
      //   x.meta.keepAlive=true
      // })

      // if (!visit.meta.noCache) {
      //   state.cachedViews.push(visit.name)
      // }

      local.setItem('visitedViews', state.visitedViews)
    },
    SET_ROUTERSdd: ((state, path) => {
      // console.log(path);
      state.showtrue = false
      let dd = state.visitedViews
      dd.forEach(x => {
        if (x.path == path) {
          state.showtrue = true
        }
      })
      window.localStorage.setItem('gotoshow', state.showtrue)
      // console.log(state.showtrue);
    }),
    DEL_VISITED_VIEWS: (state, view) => {
      for (const [i, v] of state.visitedViews.entries()) {
        if (v.path === view.path) {
          state.visitedViews.splice(i, 1)
          local.setItem('visitedViews', state.visitedViews)
          break
        }
      }
      for (const i of state.cachedViews) {
        if (i === view.name) {
          const index = state.cachedViews.indexOf(i)
          state.cachedViews.splice(index, 1)
          break
        }
      }
    },
    DEL_OTHERS_VIEWS: (state, view) => {
      for (const [i, v] of state.visitedViews.entries()) {
        if (v.path === view.path) {
          state.visitedViews = state.visitedViews.slice(i, i + 1)
          local.setItem('visitedViews', state.visitedViews)
          break
        }
      }
      for (const i of state.cachedViews) {
        if (i === view.name) {
          const index = state.cachedViews.indexOf(i)
          state.cachedViews = state.cachedViews.slice(index, index + 1)
          break
        }
      }
    },
    DEL_ALL_VIEWS: (state) => {
      state.visitedViews = []
      state.cachedViews = []
      local.setItem('visitedViews', state.visitedViews)
    },
    SET_IFRAME_TAGVIEWS(state, data) {
      state.iframeViews = { ...state.iframeViews, ...data }
    },
  },
  actions: {
    setIframeTagViews({ commit }, data) {
      commit('SET_IFRAME_TAGVIEWS', data)
    },
    addVisitedViews({ commit }, view) {
      commit('ADD_VISITED_VIEWS', view)
    },
    delVisitedViews({ commit, state }, view) {
      return new Promise((resolve) => {
        commit('DEL_VISITED_VIEWS', view)
        resolve([...state.visitedViews])
      })
    },
    delOthersViews({ commit, state }, view) {
      return new Promise((resolve) => {
        commit('DEL_OTHERS_VIEWS', view)
        resolve([...state.visitedViews])
      })
    },
    delAllViews({ commit, state }) {
      return new Promise((resolve) => {
        commit('DEL_ALL_VIEWS')
        resolve([...state.visitedViews])
      })
    },
    delAllViewsd() {

    },
  },
  getters: {
    iframeViews: (state) => state.iframeViews,
    showtrue: (state) => state.showtrue,

  },
}

export default tagsView
